import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import useOnFocusChange from '@/hooks/useOnFocusChange';
import iccConsumerProducts from '@/services/icc/iccConsumerProducts';
import {selectPendingReturnFromWebAppConnection} from '@/state/selectors/global';
import {setPendingReturnFromWebAppConnection} from '@/state/slices/globalSlice';

const useOnReturnFromWebAppConnection = () => {
    const dispatch = useDispatch();
    const isPending = useSelector(selectPendingReturnFromWebAppConnection);

    const handleFocus = useCallback(() => {
        if (!isPending) return;

        dispatch(setPendingReturnFromWebAppConnection(false));

        iccConsumerProducts.getDetailedProducts();
    }, [isPending, dispatch]);

    useOnFocusChange(handleFocus);
};

export default useOnReturnFromWebAppConnection;
